import customAxios from '@/utils/custom-axios';
import {CLAIM_REQUEST_RESULT} from './account';

const baseApiUrl = `${process.env.VUE_APP_API}/patient/account`;

export const OTP_RESPONSE_ENUM = {
  VERIFY: {
    EXPIRED: -1,
    FAILED: 0,
    VERIFY_SUCCESS: 1,
  },
  RESEND: {
    RESEND_RECENTLY_SENT_CODE: -1,
    SUCCESS_LOGIN_RESEND: 1,
    SUCCESS_REGISTER_RESEND: 2,
  },
};

export const CLAIM_OTP_RESPONSE_ENUM = {
  VERIFY: {
    CLAIM_INVALID: -2,
    CLAIM_EXPIRED: -1,
    CLAIM_FAILED: 0,
    CLAIM_SUCCESS: 1,
  },
  RESEND: {
    ...CLAIM_REQUEST_RESULT,
  },
};

export const UPDATE_MOBILE_EMAIL_OTP_ENUM = {
  INCORRECT_TOKEN: -5,
  ALREADY_TAKEN: -2,
  EXPIRED: -1,
  FAILED: 0,
  SUCCESS: 1,
};

const base = (endpoint, body) => customAxios.post(
  `${baseApiUrl}/${endpoint}`,
  body,
);

export const OtpService = {
  loginVerify: (body) => base('login/verify', body),
  loginResend: (body) => base('login/resend', body),

  registerVerify: (body) => base('register/verify', body, true),
  registerResend: (body) => base('register/resend', body, false),

  claimVerify: (body) => base('claim/verify', body, true),
  claimResend: (body) => base('claim/resend', body, false),

  mobileUpdateVerify: (body) => base('verifyupdate/mobile', body, true),
  emailUpdateVerify: (body) => base('verifyupdate/email', body, true),
};
